import { FileText, icons, type LucideIcon as LucideIconType } from 'lucide-react'

const NAME_MAP: Record<string, LucideIconType> = Object.fromEntries(
  Object.entries(icons).map(([pascal, Comp]) => {
    const kebab = pascal
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
      .toLowerCase()
    return [kebab, Comp]
  })
)

export const LUCIDE_ICON_NAMES: string[] = Object.keys(NAME_MAP).sort()

type LucideIconProps = {
  name: string | null | undefined
  className?: string
}

/**
 * Resolves a kebab-case lucide icon name (e.g. "map-pin", "wrench-2") to the
 * matching lucide-react component. Falls back to FileText for unknown names
 * so editor mistakes never crash the page.
 */
export function LucideIcon({ name, className }: LucideIconProps) {
  const Icon = (name && NAME_MAP[name]) || FileText
  return <Icon className={className} aria-hidden="true" />
}
